import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import PdfRow from './PdfRow';

const styles = StyleSheet.create(
    {
        section: { marginTop: 10, marginLeft: 20 },
        title: { fontSize: 11, marginTop: '10px', fontFamily: "RobotoRegular", color: '#005893' },
    }
)

const PdfSection = props => {
    const { name, fields, fieldDefs, fieldState, formData, meta, dataFetchResolver } = props;
    const allFieldsHidden = fields.every(field => fieldState[field].hidden);

    return <>
        {!allFieldsHidden &&
            <View style={styles.section} wrap={true}>
                <Text style={styles.title}>{name}</Text>

                {fields.map(field => {
                    const myDef = fieldDefs.filter(fd => fd.dataKey === field)[0];
                    const myState = fieldState[field];
                    const myData = formData[field];

                    if (myState.hidden) return null;

                    return <PdfRow
                        key={myDef.dataKey}
                        def={myDef}
                        data={myData}
                        dataFetchResolver={dataFetchResolver}
                        meta={meta}
                    />
                })}
            </View>
        }
    </>
}

export default PdfSection;
